import React from 'react';

const SvgMaximizeOutlined = (props) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_21702_35820)">
            <path d="M15 2.16553V3.66553H19.9395L13.5 10.102L14.5605 11.1655L21 4.72603V9.66553H22.5V2.16553H15Z" fill="#60636B"/>
            <path d="M10.5 15.2275L9.444 14.1655L3 20.605V15.6655H1.5V23.1655H9V21.6655H4.0605L10.5 15.2275Z" fill="#60636B"/>
        </g>
        <defs>
            <clipPath id="clip0_21702_35820">
                <rect width="24" height="24" fill="white" transform="translate(0 0.665527)"/>
            </clipPath>
        </defs>
    </svg>
);

export default SvgMaximizeOutlined;
